'use client';

import { useDecisions, usePageLayout } from '@libs/common-next';

import { calculateGuestTreatPoints } from '../lib/calculateGuestTreatPoints';
import { TreatPointsProps } from '../ui/TreatPoints';
import { useUserTreatPointsQuery } from './useUserTreatPointsQuery';

export const useTreatPoints = ({ sku, price, quantity, guestTreatPoints }: TreatPointsProps) => {
    const dynamicLoadTreatsPtsFF = useDecisions('ff_dynamic_tp');
    const { user } = usePageLayout();

    const shouldFetchTreatPoints = !!user?.loyaltyid && dynamicLoadTreatsPtsFF;

    const { data: userPoints, isPending: isUserPointsPending } = useUserTreatPointsQuery({
        sku,
        price,
        quantity,
        enabled: shouldFetchTreatPoints,
    });

    const guestPoints = calculateGuestTreatPoints({
        price,
        quantity,
        guestTreatPoints,
    });

    return {
        isPending: shouldFetchTreatPoints ? isUserPointsPending : false,
        treatPoints: shouldFetchTreatPoints ? (userPoints ?? guestPoints) : guestPoints,
    };
};
